var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.9V4.1C22 2.6 21.36 2 19.77 2L15.73 2C14.14 2 13.5 2.6 13.5 4.1L13.5 10.9C13.5 12.4 14.14 13 15.73 13L19.77 13C21.36 13 22 12.4 22 10.9Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.1L11.5 19.9C11.5 21.4 10.86 22 9.27 22H5.23C3.64 22 3 21.4 3 19.9L3 13.1C3 11.6 3.64 11 5.23 11L9.27 11C10.86 11 11.5 11.6 11.5 13.1Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.9V17.1C22 15.6 21.36 15 19.77 15L15.73 15C14.14 15 13.5 15.6 13.5 17.1V19.9C13.5 21.4 14.14 22 15.73 22H19.77C21.36 22 22 21.4 22 19.9Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.9V4.1C11.5 2.6 10.86 2 9.27 2L5.23 2C3.64 2 3 2.6 3 4.1L3 6.9C3 8.4 3.64 9 5.23 9H9.27C10.86 9 11.5 8.4 11.5 6.9Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItem);
export default __webpack_public_path__ + "static/media/menu-item.126c40e95ec2289cad40787603b0b314.svg";
export { ForwardRef as ReactComponent };